interface EpisodeListProps {
  total: number;
  current: number;
  onSelect: (n: number) => void;
}

export default function EpisodeList({ total, current, onSelect }: EpisodeListProps) {
  const episodes = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
      {episodes.map((n) => {
        const active = n === current;
        return (
          <button
            key={n}
            type="button"
            onClick={() => onSelect(n)}
            className={`shrink-0 w-14 h-11 flex items-center justify-center rounded-md text-sm font-label transition-colors cursor-pointer ${
              active
                ? "bg-accent-500 text-primary-950 font-semibold"
                : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
            }`}
          >
            {n}
          </button>
        );
      })}
    </div>
  );
}